import React from "react";

const JsonLd: React.FC<{ data: any }> = ({ data }) => {
  const serializedData = JSON.stringify(data).replace(/</g, "\\u003c");
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: serializedData }} />;
};

export default JsonLd;
